/** Locale-aware formatting (ADR-0011): dates, numbers, currency follow the user's locale. */

export function formatDate(iso: string, locale: string, style: 'short' | 'medium' | 'long' = 'medium'): string {
  const d = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(iso + 'T00:00:00Z') : new Date(iso);
  return new Intl.DateTimeFormat(locale, { dateStyle: style, timeZone: /^\d{4}-\d{2}-\d{2}$/.test(iso) ? 'UTC' : undefined }).format(d);
}

export function formatDateTime(iso: string, locale: string, timeZone?: string): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short', timeZone }).format(new Date(iso));
}

export function formatNumber(n: number, locale: string, maximumFractionDigits = 1): string {
  return new Intl.NumberFormat(locale, { maximumFractionDigits }).format(n);
}

export function formatCurrency(n: number, currency: string, locale: string): string {
  return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 0 }).format(n);
}

export function formatPercent(n: number, locale: string): string {
  return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 1 }).format(n / 100);
}

/** "in 12 days" / "3 days ago" for days-to-follow-up. */
export function formatRelativeDays(days: number, locale: string): string {
  return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(days, 'day');
}
